import React, { useState, useContext, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useWindowSize } from "react-use";
import { loginPages, profilePageMenu } from "../../menu";
import {
  DropdownItem,
  DropdownMenu,
} from "../../components/bootstrap/Dropdown";
import Button from "../../components/bootstrap/Button";
import useDarkMode from "../../hooks/useDarkMode";
import Collapse from "../../components/bootstrap/Collapse";
import { NavigationLine } from "../Navigation/Navigation";
import Icon from "../../components/icon/Icon";
import useNavigationItemHandle from "../../hooks/useNavigationItemHandle";
// import AuthContext from '../../contexts/authContext';
import ThemeContext from "../../contexts/themeContext";
import { getLoginObjDetails } from "../../redux/login/login.selector";
import UserImageWebp from "../../assets/img/wanna/wanna1.webp";
import UserImage from "../../assets/img/wanna/wanna1.png";
import { userSignInLogOutStart } from "../../redux/login/login.action";
import { s3BaseUrl } from "../../redux/const";

const User = () => {
  const dispatch = useDispatch();
  const { width } = useWindowSize();
  const { setAsideStatus } = useContext(ThemeContext);
  // const { userData, setUser } = useContext(AuthContext);
  const loginDetails = useSelector(getLoginObjDetails);
  const { UserLevel, UserName } = loginDetails;

  const navigate = useNavigate();
  const handleItem = useNavigationItemHandle();
  const { darkModeStatus, setDarkModeStatus } = useDarkMode();

  const [collapseStatus, setCollapseStatus] = useState<boolean>(false);

  const { t } = useTranslation(["translation", "menu"]);

  function logout() {
    if (width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)) {
      setAsideStatus(false);
    }
    const reducedMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const finish = () => {
      document.body.classList.remove("phx-signing-out");
      dispatch(userSignInLogOutStart());
      navigate(`../${loginPages.login.path}`);
    };
    if (reducedMotion) {
      finish();
      return;
    }
    // Blur-out the app shell before returning to the login stage.
    document.body.classList.add("phx-signing-out");
    window.setTimeout(finish, 420);
  }
  return (
    <>
      <div
        className={classNames("user", { open: collapseStatus })}
        role="presentation"
        onClick={() => setCollapseStatus(!collapseStatus)}
      >
        <div className="user-avatar">
          {loginDetails?.UserPhoto !== "" && loginDetails?.UserPhoto !== "-" ? (
            <img
              src={
                loginDetails?.UserPhoto.includes("http") ||
                loginDetails?.UserPhoto.startsWith("data:image")
                  ? loginDetails?.UserPhoto
                  : `${s3BaseUrl}${loginDetails?.UserPhoto}`
              }
              alt="Avatar"
              width={128}
              height={128}
            />
          ) : (
            <img
              srcSet={UserImageWebp}
              src={UserImage}
              alt="Avatar"
              width={128}
              height={128}
            />
          )}
          {/* {UserLevel == "Level0" ? (
            <>
              <div> (Lead Source)</div>
              <div>{UserName}</div>
            </>
          ) : UserLevel == "Level100" ? (
            <>
              <div>Admin</div>
              <div>{UserName}</div>
            </>
          ) : UserLevel == "Level101" ? (
            <>
              <div>(Super Admin)</div>
              <div>{UserName}</div>
            </>
          ) : UserLevel == "Level2" ? (
            <>
              <div> (Broker)</div>
              <div>{UserName}</div>
            </>
          ) : null} */}
        </div>
        <div className="user-info">
          <div className="user-name d-flex align-items-center">
            {/* {`${loginDetails?.userName}`} */}
            {UserLevel === "Level0" ? (
              <>
                <div>
                  Lead Source
                  <br />
                  {UserName}
                </div>
              </>
            ) : UserLevel === "Level100" ? (
              <>
                <div>
                  Admin <br />
                  {UserName}
                </div>
              </>
            ) : UserLevel === "Level101" ? (
              <>
                <div>
                  Super Admin <br />
                  {UserName}
                </div>
              </>
            ) : UserLevel === "Level2" ? (
              <>
                <div>
                  Broker
                  <br />
                  {UserName}
                </div>
              </>
            ) : UserLevel === "Level1" ? (
              <>
                <div>
                  Team Leader
                  <br />
                  {UserName}
                </div>
              </>
            ) : UserLevel === "Level4" ? (
              <>
                <div>
                  Sub Admin
                  <br />
                  {UserName}
                </div>
              </>
            ) : UserLevel === "Level3" ? (
              <>
                <div>
                  HR
                  <br />
                  {UserName}
                </div>
              </>
            ) : (
              <>
                <div>Login</div>
              </>
            )}
            <Icon icon="Verified" className="ms-1" color="info" />
          </div>
          <div className="user-sub-title">{loginDetails?.UserPhoneNumber}</div>
        </div>
      </div>
      <DropdownMenu>
        <DropdownItem>
          <Button
            icon="AccountBox"
            onClick={() => navigate(`../${profilePageMenu.profile.path}`)}
          >
            Profile
          </Button>
        </DropdownItem>
        <DropdownItem>
          <Button
            icon={darkModeStatus ? "DarkMode" : "LightMode"}
            onClick={() => setDarkModeStatus(!darkModeStatus)}
            aria-label="Toggle fullscreen"
          >
            {darkModeStatus ? "Dark Mode" : "Light Mode"}
          </Button>
        </DropdownItem>
      </DropdownMenu>

      <Collapse isOpen={collapseStatus} className="user-menu">
        <nav aria-label="aside-bottom-user-menu">
          <div className="navigation">
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() =>
                navigate(
                  `../${profilePageMenu.profile.path}`,
                  // @ts-ignore
                  // handleItem(),
                )
              }
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="AccountBox" className="navigation-icon" />
                  <span className="navigation-text">
                    {t("menu:Profile") as ReactNode}
                  </span>
                </span>
              </span>
            </div>
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => {
                setDarkModeStatus(!darkModeStatus);
                handleItem();
              }}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon
                    icon={darkModeStatus ? "DarkMode" : "LightMode"}
                    color={darkModeStatus ? "info" : "warning"}
                    className="navigation-icon"
                  />
                  <span className="navigation-text">
                    {darkModeStatus
                      ? (t("menu:DarkMode") as ReactNode)
                      : (t("menu:LightMode") as ReactNode)}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </nav>
        <NavigationLine />
        <nav aria-label="aside-bottom-user-menu-2">
          <div className="navigation">
            <div
              role="presentation"
              className="navigation-item cursor-pointer"
              onClick={() => {
                logout();
              }}
            >
              <span className="navigation-link navigation-link-pill">
                <span className="navigation-link-info">
                  <Icon icon="Logout" className="navigation-icon" />
                  <span className="navigation-text">
                    {t("menu:Logout") as ReactNode}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </nav>
      </Collapse>
    </>
  );
};

export default User;
